import apiClient from './apiClient';

export interface UserProfile {
  id: string;
  email: string;
  name: string;
  firstName: string;
  lastName: string;
  first_name: string;
  last_name: string;
  timezone: string;
  zipCode: string;
  zip_code: string;
  avatarUrl?: string;
  avatar_url?: string;
  profile_picture?: string;
  status: string;
  created_at: string;
  updated_at: string;
  // Default location fields (from backend profile endpoint)
  defaultLocationLat?: number | null;
  defaultLocationLng?: number | null;
  defaultLocationAddress?: string;
  // Legacy snake_case fields (for compatibility)
  location_lat?: number;
  location_lng?: number;
  location_address?: string;
}

export interface UpdateProfileData {
  firstName?: string;
  lastName?: string;
  timezone?: string;
  zipCode?: string;
  avatarUrl?: string;
}

export interface UserPreferencesData {
  preferences?: string[];
  favoriteCuisines?: string[];
  dietaryRestrictions?: string[];
  accessibilityNeeds?: string[];
  completedAt?: string;
}

export interface LocationData {
  latitude: number;
  longitude: number;
  address?: string;
  zipCode?: string;
}

export const userApi = {
  // Get current user profile
  getProfile: async (): Promise<UserProfile> => {
    const response = await apiClient.api.get('/v1/users/profile');
    return response.data.data;
  },

  // Get public profile by user ID
  getPublicProfile: async (userId: string): Promise<Partial<UserProfile>> => {
    const response = await apiClient.api.get(`/v1/users/profile/${userId}`);
    return response.data.data;
  },

  // Update user profile
  updateProfile: async (data: UpdateProfileData): Promise<UserProfile> => {
    const response = await apiClient.api.put('/v1/users/profile', data);
    return response.data.data;
  },

  // Update user location
  updateLocation: async (data: LocationData): Promise<void> => {
    await apiClient.api.post('/v1/users/location', data);
  },

  // Change password
  changePassword: async (currentPassword: string, newPassword: string): Promise<void> => {
    await apiClient.api.post('/v1/users/change-password', {
      currentPassword,
      newPassword
    });
  },

  // Update user preferences (cuisines, dietary restrictions, accessibility needs)
  updatePreferences: async (data: UserPreferencesData): Promise<void> => {
    await apiClient.api.put('/v1/preferences/profile', data);
  },

  // Get user preferences
  getPreferences: async (): Promise<any | null> => {
    try {
      const response = await apiClient.api.get('/v1/preferences');
      return response.data;
    } catch {
      return null;
    }
  }
};